import "./wdyr";
import React from "react";
import ReactDOM from "react-dom/client";
import "./App.scss";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/auth.context";
import { ensureFreshServiceWorker } from "./ensureFreshSW";
import { initHotjarIdentity } from "./Utils/hotjar";
import { initTelemetry } from "./telemetry/bootstrap";

// Activate the white-label theme scope before first paint so the brand tokens
// (see src/Styles/abstracts/_tokens.scss) apply without a flash of the default theme.
if (process.env.REACT_APP_IS_STYLEMATCH_ENV === "true") {
  document.documentElement.setAttribute("data-tenant", "stylematch");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Wire Hotjar identity tagging (widget sessionId + PWA anon uid) before the app
// mounts, so the ttf:sharing-updated listener is active before any route writes
// the sessionId. See src/Utils/hotjar.ts.
initHotjarIdentity();

// Telemetry bootstrap: bind the unload hooks, emit the `app.pageload` anchor
// row, open the `boot` phase, and drain any rows a previous page load could not
// confirm. Bound BEFORE the app mounts so a session that dies on the splash
// still leaves a trail. Fire-and-forget. See docs/telemetry/PLAN.md.
initTelemetry();

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Register service worker
serviceWorkerRegistration.register();

ensureFreshServiceWorker();

// Report performance metrics
reportWebVitals();
